import { getGlobals, getArchive } from "storyblok/api"
import Meta from "components/Meta"
import { getStatePaths, getArchiveOfficesByState } from "storyblok/offices"
import DynamicComponent from "components/DynamicComponent"
import SimpleArchiveSection from "components/Archive/SimpleArchiveSection"
import OfficeCard from "components/OfficeCard"
import ArchiveHeader from "components/Archive/ArchiveHeader"
import { CardListSection } from "components/Archive/CardListSection"
import { getArchiveOfficesApi } from "storyblok/officesApi"

export default function TeamMemberArchive({ meta, story, items, perPage, total, currentPage, state }) {

  return (
    <>
      <Meta info={meta} />
      <main data-pagefind-ignore="all">
        <ArchiveHeader story={story?.content} breadcrumbs={[{ last: "state", text: "Office Locations", href: "/office-locations" }]} />
        <SimpleArchiveSection
          list={
            <CardListSection
              items={items}
              total={total}
              perPage={perPage}
              currentPage={currentPage}
              stateFilter={state}
              columns={4}
              handler={(params) => getArchiveOfficesApi(params)}
              Card={OfficeCard}
            />
          }
          
        />
          {story?.content?.body?.map((blok) => (
          <DynamicComponent blok={blok} key={blok._uid} />
        ))}
      </main>
    </>
  )
}

export async function getStaticProps({params, preview = null }) {
  const globals = await getGlobals()

  const archive = `office-locations/${params.state}`

  const story = await getArchive(archive, preview)

  const  { items, currentPage, total, perPage }= await getArchiveOfficesByState({per_page: 100, page: 1}, params.state)


  return {
    props: {
      story: story ?? null,
      meta: story?.content?.twentysixty_seo ?? null,
      items,
      currentPage,
      total,
      perPage,
      state: params.state,
      globals: globals ?? null,
      preview,
    },
  }
}

export async function getStaticPaths() {
  return {
    paths: await getStatePaths(),
    fallback: false,
  }
}
